import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-i18nify';
import { Link, browserHistory } from 'react-router';
import { Layout, Menu, Dropdown } from 'antd';
import { userLogout, listInfoTexts } from 'actions/actions';
import CIBCardLogos from './CIB_es_kartyalogok_85px_vrt_HU.png';
import OTPCardLogos from './simplepay_bankcard_logos_top_02.png';
import KHCardLogos from './KHCardLogos.png';


const { Header, Content } = Layout;
const appMenu = [
  { link: '/dashboard', label: 'események', isAdminRoute: false },
  { link: '/admin/conferences', label: 'admin', isAdminRoute: true },
  { link: '/admin/infos', label: 'szöveges tartalmak', isAdminRoute: true },
];

function handleLoadProfilePage() { // eslint-disable-line
  browserHistory.push('/profile');
}

function renderAppMenu(userIsAdmin) {
  return appMenu.map((menu) => {
    const routeItem = (
      <Link
        key={menu.link}
        className="app-menu-item"
        activeStyle={{ color: '#0d4e63', borderColor: '#0d4e63' }}
        to={menu.link}
      >
        {menu.label}
      </Link>
    );

    if (menu.isAdminRoute) {
      return userIsAdmin ? routeItem : null;
    }

    return routeItem;
  });
}

function renderLoginMenu() {
  return null;
}


export class PageLayout extends React.Component {
  constructor(props) {
    super(props);

    this.renderUserMenu = this.renderUserMenu.bind(this);
    this.handleUserMenuClick = this.handleUserMenuClick.bind(this);

    this.props.listInfoTexts();
  }

  handleUserMenuClick(e) {
    switch (e.key) {
      /*
        case '1': {
          handleLoadProfilePage();
          break;
        }
      */

      case 'billing-info': {
        browserHistory.push('/profile/billing-info');
        break;
      }

      case 'change-password': {
        browserHistory.push('/profile/change-password');
        break;
      }

      case 'logout': {
        this.props.userLogout();
        break;
      }

      default:
    }
  }

  renderUserMenu(userMenu) {
    return (
      <Dropdown.Button
        overlay={userMenu}
        trigger={['click']}
      >
        {this.props.user.email}
      </Dropdown.Button>
    );
  }

  render() {
    const menu = (
      <Menu onClick={this.handleUserMenuClick}>
        {/*
          <Menu.Item key="1">{I18n.t('usermenu.my_profile')}</Menu.Item>
          <Menu.Divider />
        */}
        <Menu.Item key="billing-info">{I18n.t('usermenu.billing_info')}</Menu.Item>
        <Menu.Item key="change-password">{I18n.t('usermenu.change_password')}</Menu.Item>
        <Menu.Item key="logout">{I18n.t('usermenu.logout')}</Menu.Item>
      </Menu>
    );

    return (
      <Layout className="app">
        <Header>
          <div className="header-container">
            <Link to="/">
              <div className="logo">
                RKK
              </div>
            </Link>

            <div className="header-app-menu">
              {this.props.user.isAuthenticated
                ? renderAppMenu(this.props.user.admin)
                : null
              }
            </div>
            {this.props.user.isAuthenticated
              ? this.renderUserMenu(menu)
              : renderLoginMenu()
            }
          </div>
        </Header>
        <Content className={this.props.user.isAuthenticated ? '' : 'no-user'}>
          <div className="ant-layout-content-wrapper">
            {this.props.children}
          </div>
          <div className="layout-footer">
            <div className="card-logos">
              <img src={CIBCardLogos} alt="CIB kártya logok" height={85} />
              <img src={OTPCardLogos} alt="OTP kártya logok" height={85} />
              <img src={KHCardLogos} alt="K&H SZÉP kártya" height={85} />
            </div>
            <div className="footer-links">
              {
                this.props.footerLinks.map(link => (
                  <Link key={link.id} to={`/info/${link.permalink}`} className="footer-link">
                    {link.name}
                  </Link>
                ))
              }
            </div>
            <div>RKK, Minden jog fenntartva ©{new Date().getFullYear()}</div>

            <div>
              <span>Magyarországi Református Egyház; </span>
              <span>1146 Budapest Abonyi utca 21.; </span>
              <span>Adószám: 19024048-1-42; </span>
              <span>Cégjegyzékszám: 00002/2012; </span>
              <span>rkk@reformatus.hu</span>
            </div>
          </div>
        </Content>
      </Layout>
    );
  }
}

PageLayout.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    admin: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
  }).isRequired,
  footerLinks: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  children: PropTypes.element.isRequired,
  userLogout: PropTypes.func.isRequired,
  listInfoTexts: PropTypes.func.isRequired,
};

const mapActionCreators = {
  userLogout,
  listInfoTexts,
};

const mapStateToProps = state => ({
  user: state.user,
  footerLinks: state.textInfos.footerLinks,
});

export default connect(mapStateToProps, mapActionCreators)(PageLayout);



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/layouts/PageLayout/PageLayout.js